export default "__VITE_ASSET__BbItxBdj__"